/**
 * throttleAnimation
 * only runs the wrapped function once per animation frame.
 * useful for responding to high frequency browser events
 *
 * TODO React17 (kyle): reevaluate this function upon the release of react 17.
 * possible that async setState() will need to be explicitly flushed.
 */
export default function throttleAnimation<
  F extends (...params: unknown[]) => void,
>(fn: F): (...params: unknown[]) => void {
  // @ts-expect-error - TS7034 - Variable 'rafId' implicitly has type 'any' in some locations where its type cannot be determined.
  let rafId = null;
  let savedParams: Array<unknown> | Array<never> = [];
  return function (...params): undefined {
    savedParams = params;
    // @ts-expect-error - TS7005 - Variable 'rafId' implicitly has an 'any' type.
    if (!rafId) {
      rafId = requestAnimationFrame(() => {
        rafId = null;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        fn.apply(this, savedParams);
        savedParams = [];
      });
    }
  };
}
